/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import "./LandingPage.css";

export const Footer = () => {
  const history = useHistory();
  const location = useLocation();

  const navigateToSection = (sectionId) => {
    if (location.pathname !== "/") {
      history.push("/");
      setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        {/* ── Top grid: brand + 3 columns ── */}
        <div className="footer-top">
          {/* Brand */}
          <div className="footer-brand">
            <div className="footer-logo-text">
              <span className="footer-logo-wordmark">
                Virdio<span>Health</span>
              </span>
            </div>
            <p className="footer-tagline">AI-powered MSK recovery, built around Myra. Clinically validated outcomes at a cost that transforms the conversation for self-funded employers.</p>
          </div>

          {/* display:contents — three cols become direct grid children */}
          <div className="footer-columns">
            {/* Platform */}
            <div className="footer-col">
              <p className="footer-col-title">Platform</p>
              <button onClick={() => navigateToSection("myra")}>Meet Myra</button>
              <button onClick={() => navigateToSection("members")}>How It Works</button>
              <button onClick={() => navigateToSection("members")}>For Members</button>
            </div>

            {/* Employers / Partners */}
            <div className="footer-col">
              <p className="footer-col-title">Employers/Partners</p>
              <button onClick={() => navigateToSection("employers")}>Comparison</button>
              <button onClick={() => navigateToSection("results")}>ROI Calculator</button>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.replace("https://myptmyra.com/intake/lower-back");
                }}
              >
                See Myra in Action
              </a>
            </div>

            {/* Company */}
            <div className="footer-col">
              <p className="footer-col-title">Company</p>
              <Link to="/about-us">About Us</Link>
              <Link to="/contact-us">Contact</Link>
              <Link to="/news">News</Link>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <span>&copy; 2026 Virdio Health, Inc. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
};
